import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import store from '../../store';
import { EPISODE_LOAD } from '../../store/actions';

import Modal from '../../components/common/dialog/dialog.vue';
import Spinner from '../../components/common/spinner/spinner.vue';
import EpisodeDetails from '../../components/episode-details/episode-details.vue';
import ClipDetails from '../../components/clip-details/clip-details.vue';
import VideoItem from './video-item/video-item.vue';

import { dialogue } from '../../helpers/clip.helpers';

import Crud, { CLIPS, METADATA, TIMEDATA } from '../../api/crud';
import vtt from '../../api/vtt';

const OPTIONS = {
   showHeader: false,
   showFooter: false
};

const api = new Crud(CLIPS);
const metadataAPI = new Crud(METADATA);
const timedataAPI = new Crud(TIMEDATA);

export default {
   name: 'VideoInfoDialog',
   store,
   components: { Modal, EpisodeDetails, ClipDetails, Spinner, VideoItem },
   data() {
      return {
         resolvedValue: null,
         loading  : false,
         collapsed: false,
         episode  : null,
         clips    : [],
         clip     : null,
         metadata : [],
         timedata : [],
         transcripts: [],
         opts     : { ...OPTIONS }
      };
   },
   computed: {
      ...mapGetters(['getCurrentShowId']),

      dialogue() {
         if (!this.clip) {
            return '';
         }
         const d = dialogue(this.clip.tcIn, this.clip.tcOut, this.transcripts);
         // textContent(dialogue).split('\n').join('<br/>')
         return d ? d.split('\n').join('<br/>') : '';
      }
   },
   methods: {
      ...mapActions({
         loadEpisode: EPISODE_LOAD
      }),
      async load(episodeId, clipId) {
         this.loading = true;

         const params = { episodeId };

         const requests = [
            this.loadEpisode(episodeId),
            api.load(params),
            metadataAPI.load(params),
            timedataAPI.load(params)
         ];
         if (clipId) {
            requests.push(api.get(clipId));
         }

         try {
            const [ episode, clips, metadata, timedata, clip ] = await Promise.all(requests);
            this.episode = episode;
            this.clips = clips;
            this.metadata = metadata;
            this.clip = clip;
            this.timedata = timedata;
         } catch(e) {
            // noop
         }
         this.refreshTranscripts();
         this.loading = false;
      },
      async select(clip) {
         this.clip = clip;
      },
      async refreshTranscripts() {
         if (!this.episode || !this.episode.ccUrl) {
            return;
         }
         try {
            this.transcripts = await vtt.load(this.episode.ccUrl);
         } catch(e) {
            //
         }
      },
      close() {
         this.$emit('close');
      }
   },
   mounted() {
      this.collapsed = this.$options.collapsed || false;
      this.load(this.$options.episodeId, this.$options.clipId);
   }
};
